import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Cacheable } from "./cacheable.service";

@Injectable({
  providedIn: "root",
})
export class HttpCommonService<T> {
  public cachedData: Cacheable<T>;

  constructor(private http: HttpClient) {
    this.cachedData = new Cacheable<T>();

    //console.log("service initialization type of:" + typeof (this.cachedData));
  }

  public getFile(url: string, parameters: any): any {
    let buildApiUrl = environment.apiConfig.apiUrl;
    var apiUrl: string = `${buildApiUrl}/${url}`;
    if (parameters) {
      apiUrl = `${buildApiUrl}/${url}&${parameters}`;
    }
    console.log("execute http:get for this api: " + apiUrl);
    return this.http.get(apiUrl, { responseType: "blob" });
  }

  public get(url: string, parameters: any): Observable<T> {
    //console.log("execute http:get for this api: " + url);

    let apiUrl = `${environment.apiConfig.apiUrl}/${url}`;

    if (parameters) {
      apiUrl = `${environment.apiConfig.apiUrl}/${url}&${parameters}`;
    }

    return this.http.get(apiUrl) as Observable<T>;
  }

  public post(url: string, parameters: any): Observable<T> {
    //console.log("execute http:post for this api: " + url);

    const apiUrl = `${environment.apiConfig.apiUrl}/${url}`;
    return this.http.post(apiUrl, parameters) as Observable<T>;
  }

  // #CoopTemplate
  public getHttpData(url: string, objectName: string): Observable<T> {
    //console.log("execute getHttpData:get for this api: " + url);

    const apiUrl = `${environment.apiConfig.apiUrl}/${url}`;

    this.cachedData.getHandler = () => {
      return this.http.get(apiUrl).pipe(map((r: any) => r));
    };

    return this.getCachedData();
  }

  public getCachedData(): Observable<T> {
    //console.log("execute getCachedData");

    return this.cachedData.getData();
  }

  public refresh(): Observable<any> {
    //console.log("execute refresh");

    return this.cachedData.refresh();
  }
}
